import { render, staticRenderFns } from "./UsefulResource.vue?vue&type=template&id=2c3bf709&scoped=true&"
import script from "./UsefulResource.vue?vue&type=script&lang=js&"
export * from "./UsefulResource.vue?vue&type=script&lang=js&"
import style0 from "./UsefulResource.vue?vue&type=style&index=0&id=2c3bf709&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3bf709",
  null
  
)

export default component.exports